import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import Auth from '../../../../Layout/Auth';

// Lazy load components
const CategoryList = lazy(() => import('../Pages/CategoryList'));
const CategoryAdd = lazy(() => import('../Pages/CategoryAdd'));
const CategoryEdit = lazy(() => import('../Pages/CategoryEdit'));
const CategoryView = lazy(() => import('../Pages/CategoryView'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Loading component
const Loading = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
    <FadeLoader color="#4e73df" loading={true} />
  </div>
);

function CategoryRoute() {
  const history = useHistory();
  
  return (
    <Switch>
      <Route
        exact
        path="/:lng/category"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <CategoryList history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/category/list"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <CategoryList history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/category/add"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
            <Suspense fallback={<Loading />}>
              <CategoryAdd history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/category/edit/:slack"
        render={(props) => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
            <Suspense fallback={<Loading />}>
              <CategoryEdit {...props} history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/category/view/:slack"
        render={(props) => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <CategoryView {...props} history={history} />
            </Suspense>
          </Auth>
        )}
      />
    </Switch>
  );
}

export default connect()(CategoryRoute);
